import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { truncate } from 'utils/string-utils';
import PageHeader from 'components/page-header'
import MeasurementReportSearchFilter from 'components/client-measurement-report/report-search-filter'
import Table from 'components/table'
import { useGetMeasurementReportsQuery, useDownloadMeasurementReportsMutation } from 'actions/client/client-dosemeter-measurement-api';
import { translationApi  } from 'actions/translation-api';
import { changePage  } from 'store/client/slice.measurement-report-list-filter';
import { showErrorNotification } from "actions/action-complete-notificator";

const MeasurementReportList = () => {
	const dispatch = useDispatch();

	const measurementReportListFilter = useSelector(state => state.measurementReportListFilter);
	const { data: measurementReportList } = useGetMeasurementReportsQuery(measurementReportListFilter, { refetchOnMountOrArgChange: true });
	const [ downloadMeasurementReportsAction ] = useDownloadMeasurementReportsMutation();
	const translations = useSelector(translationApi.endpoints.getTranslations.select()).data ?? {};

	const changeMeasurementReportListPage = (filterChange) => {
        dispatch(changePage(filterChange.page));
	}

	const downloadReport = async (measurementReport) => {
		const result = await downloadMeasurementReportsAction(measurementReport);
		if ('error' in result) {
			showErrorNotification(result.error);
		}
	}

	const getPageHeader = () => {
		return <PageHeader title={translations.measurementReportList} buttons={[]} breadcrumbs={[]} breadcrumbsCurrentPage={translations.measurementReportList} />
	}

	const pageHeader = getPageHeader();
	const headers = [translations.reportNumber, translations.readingDate, translations.clientNumberShort, translations.client, translations.deliveryAddress, translations.actions];
	let rows = [];
	if (measurementReportList && measurementReportList.measurementReports) {
		rows = measurementReportList.measurementReports.map(function (report) {
			return {
				columns: [
					report.clientDosemeterMeasurementReportNumber,
					report.clientDosemeterMeasurementResultReadingDate.slice(0,10),
					report.clientId?.toString().padStart(4, '0'),
					truncate(report.clientName, 30),
					`${report.deliveryAddressStreet}, ${report.deliveryAddressPostalCode} ${report.deliveryAddressCity}`
				],
				tooltips: [null, null, report.clientName, null, null],
				buttons: [
					<button type="button" key={"download" + report.clientDosemeterMeasurementReportId} onClick={async () => {await downloadReport(report)}} className="btn btn-sm btn-gray-800 p-1 me-2" >{translations.actionDownload}</button>
				]
			}
		}, this);
	}

	return (
		<div>
			{pageHeader}
			<MeasurementReportSearchFilter />
			<Table fetchList={changeMeasurementReportListPage} headers={headers} rows={rows} pagination={measurementReportList?.pagination} translations={translations} />
		</div>
	);
}

export default MeasurementReportList;
